import * as THREE from 'three'
import { Component } from "@ecs/Component";
export class DirectionalLight extends Component {
    light!: THREE.DirectionalLight
    offsetVector = new THREE.Vector3(10, 10, 10)
    shadowEnabled = true
    shadowMapSize = 1024 * 8
    shadowDistance = 25
    shadowNear = 0.1
    shadowFar = 100
    shadowRadius = 1
    setup(data: any) {
        data;
        this.light = new THREE.DirectionalLight(0xffffff, 1)
        this.light.target = data.target

        if (data.shadowMapSize) this.shadowMapSize = data.shadowMapSize
        if (data.shadowDistance) this.shadowDistance = data.shadowDistance
        if (data.shadowNear) this.shadowNear = data.shadowNear
        if (data.shadowFar) this.shadowFar = data.shadowFar
        if (data.shadowRadius) this.shadowRadius = data.shadowRadius
        if (data.offsetVector) this.offsetVector = data.offsetVector
        this.shadowEnabled = data.shadowEnabled ?? true
    }
    start() {

        this.light.name = this.gameObject.name

        if (this.shadowEnabled) {
            this.light.shadow.camera.near = this.shadowNear
            this.light.shadow.camera.far = this.shadowFar
            this.light.shadow.radius = this.shadowRadius
            const d = this.shadowDistance
            this.light.shadow.camera.left = -d
            this.light.shadow.camera.right = d
            this.light.shadow.camera.top = d
            this.light.shadow.camera.bottom = -d
            this.light.shadow.camera.updateProjectionMatrix()
            const shadowRes = this.shadowMapSize
            this.light.shadow.mapSize.set(shadowRes, shadowRes)
        }
        this.light.castShadow = this.shadowEnabled
        this.scene.threeScene.add(this.light)

    }
    update(_dt: number) {
        this.light.position.copy(this.offsetVector).add(this.light.target.position)
    }
    onDestroy() {
        //free all resources
        this.scene.threeScene.remove(this.light)
        this.light.dispose()

    }
}
